import * as t from "react";
import e from "../lib/IconBase.es.js";
import s from "../defs/HashStraight.es.js";
const a = t.forwardRef((o, r) => /* @__PURE__ */ t.createElement(e, { ref: r, ...o, weights: s }));
a.displayName = "HashStraightIcon";
const c = a;
export {
  c as HashStraight,
  a as HashStraightIcon
};
